import { api } from "./client";

export const ReportsAPI = {
  assetHistory: (params = {}) => api.get("/reports/asset-history", { params }),
  downloadExecutivePdf: () => api.get("/reports/executive.pdf", { responseType: "blob" }),
  getDeliverySettings: () => api.get("/reports/delivery-settings"),
  updateDeliverySettings: (payload) => api.put("/reports/delivery-settings", payload),
  sendDeliveryTest: () => api.post("/reports/delivery-settings/test"),
  auditOverview: () => api.get("/reports/audit-overview"),
  startAuditRun: (payload = {}) => api.post("/reports/audit-runs/start", payload),
  getActiveAuditRun: () => api.get("/reports/audit-runs/active"),
  listAuditRunScans: (runId) => api.get(`/reports/audit-runs/${runId}/scans`),
  listPendingSelfScans: (runId) => api.get(`/reports/audit-runs/${runId}/scans`),
  approveSelfScan: (scanId) => api.post(`/reports/audit-scans/${scanId}/approve`),
  sendSelfScanForReview: (scanId, payload = {}) => api.post(`/reports/audit-scans/${scanId}/review`, payload),
  rejectSelfScan: (scanId, payload = {}) => api.post(`/reports/audit-scans/${scanId}/reject`, payload),
  completeAuditRun: (runId) => api.post(`/reports/audit-runs/${runId}/complete`),
  listAuditRuns: (params = {}) => api.get("/reports/audit-runs", { params }),
  downloadAuditRunCsv: (runId) =>
    api.get(`/reports/audit-runs/${runId}/download.csv`, { responseType: "blob" }),
  inventoryInsights: (params = {}) => api.get("/reports/inventory/insights", { params }),
  financeDepreciation: (params = {}) => api.get("/reports/finance/depreciation", { params }),
  financeFraudSignals: () => api.get("/reports/finance/fraud-signals"),
  financeTallyPreview: (payload = {}) => api.post("/reports/finance/tally/preview", payload),
  financeTallySync: (payload = {}) => api.post("/reports/finance/tally/sync", payload),
  itIdleUnderutilized: (params = {}) => api.get("/reports/it/idle-underutilized", { params }),
  cloudBudgetInsights: (params = {}) => api.get("/reports/cloud/budget-insights", { params }),
  upsertCloudBudget: (payload = {}) => api.post("/reports/cloud/budgets", payload),
};
